const pre = 'common-';

export default [{
        path: '/common/me',
        name: `${pre}me`,
        meta: {
            title: '个人中心'
        },
        component: () =>
            import ('@/views/common/me')
    },
    {
        path: '/common/userInfo',
        name: `${pre}userInfo`,
        meta: {
            title: '用户资料'
        },
        component: () =>
            import ('@/views/common/userInfo')
    },
    {
        path: '/common/modifyUserInfo',
        name: `${pre}modifyUserInfo`,
        meta: {
            title: '修改用户资料'
        },
        component: () =>
            import ('@/views/common/modifyUserInfo')
    }
]